import React from 'react';
import PropTypes from 'prop-types';
import Button from '../button/Button';

const getHeaderText = (isSecure, mainTitle) =>
    isSecure ? (
        <>
            Scores you enter are saved automatically. To delete a previously entered score, click{' '}
            <span>Invalidate</span>. To modify a score, click <span>Invalidate</span> and enter the
            new score. <br />
            Important: {mainTitle} benchmark web entry is not available during the EOY and post-EOY
            periods.
        </>
    ) : (
        <>
            Scores you enter are saved automatically. To delete a previously entered score, click{' '}
            <span>Invalidate</span>. To modify a score, click <span>Invalidate</span> and enter the
            new score.
        </>
    );

const WebEntryPanelHeader = ({
    headerTitle,
    mainTitle,
    onClose,
    isPanelUpdating,
    headerErrorText,
    hasErrors,
    webEntryClassName,
    isSecureHeaderText,
}) => (
    <div className="sticky-header-container">
        <div className={`${webEntryClassName}-header`}>
            <h3>{headerTitle}</h3>
            <p className={`${webEntryClassName}-header-text`}>
                {getHeaderText(isSecureHeaderText, mainTitle)}
            </p>
            <div className={`${webEntryClassName}-header-button`}>
                <Button
                    className="btn btn-oval"
                    text="Done"
                    onClick={onClose}
                    isDisabled={isPanelUpdating}
                />
            </div>
        </div>
        {hasErrors && (
            <div className={`${webEntryClassName}-header-warning`}>
                <i className="icon-amplify-caution" />
                <span className={`${webEntryClassName}-header-error-text`}>{headerErrorText}</span>
            </div>
        )}
    </div>
);

WebEntryPanelHeader.defaultProps = {
    onClose: () => {},
    isPanelUpdating: false,
    headerErrorText: (
        <>
            Please fix errors in the highlighted cells. <br />
        </>
    ),
    headerTitle: 'Web Entry Panel',
    hasErrors: false,
    isSecureHeaderText: false,
    mainTitle: 'Maze',
};

WebEntryPanelHeader.propTypes = {
    onClose: PropTypes.func,
    isPanelUpdating: PropTypes.bool,
    headerTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    headerErrorText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    hasErrors: PropTypes.bool,
    webEntryClassName: PropTypes.string.isRequired,
    isSecureHeaderText: PropTypes.bool,
    mainTitle: PropTypes.string,
};

export default WebEntryPanelHeader;
